import React from 'react'

var d = new Date();
var currYear = d.getFullYear();
export const Footer = (props) => {
  
  return (
    <div id='footer'>
    <div className='container text-center'>
    <div className="about-social-icon text-center">
    

    
    </div>
      <p>
      Copyright  {currYear}. All rights reserved &copy;  RO Service Center Near me {' '} | <a href='/privacy-policy' > Privicy Policies </a>
      </p>
      
    </div>
      </div>
  )
}

